import { FilterGroup } from 'types';

const createFilters = (): FilterGroup[] => [
  {
    id: 1,
    filters: [
      {
        name: 'email',
        label: 'Email',
      },
      {
        name: 'name',
        label: 'Name',
      },
      {
        name: 'surname',
        label: 'Last Name',
      },
    ],
  },
];

export { createFilters };
